// extracted by mini-css-extract-plugin
export default {"authHeader":"AuthHeader_authHeader__emxB0","logo":"AuthHeader_logo__T4vOU","title":"AuthHeader_title__hemCG"};